import { createEvent } from 'effector';
import { Product } from '../../../types/common';

export const addToCart = createEvent<Product>();
export const removeFromCart = createEvent<string>();
export const updateCartItemQuantity = createEvent<{ id: string; quantity: number }>();
